"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
let BlockDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.second = 5;
    this.user_id = "";
    this.showClose = false;
  }
  // id:string
  open() {
    return __async(this, null, function* () {
      this.BlockDialog.show();
    });
  }
  //   timer_last() {
  //     let timer_last = setInterval(() => {
  //       if (this.second >= 0) {
  //         this.second = this.second - 1;
  //       }
  //       if (this.second === 0) {
  //         this.showClose = true;
  //       }
  //       if (this.second < 0) {
  //         clearInterval(timer_last);
  //         this.second = 5;
  //       }
  //     }, 1000);
  //   }
  //   async closeNoticeDialog() {
  //     try {
  //       await API.put(`api://base.local/storages/session/core_upgrade_notice`,{
  //         "model":"browser.version.check",
  //         "flag":"false"
  //       })
  //       this.close();
  //     } catch (error: any) {
  //       if (error.hasOwnProperty("response")) {
  //         this.$message.error(error.response.data.errors.datas[0].message);
  //       }
  //     }
  //   }
  //   openDownloadWin7() {
  //     window.open("https://www.kuajingvs.com/download-win32", "__blank")
  //   }
  //   openHelpPage() {
  //     window.open("https://www.kuajingvs.com/help2/25371", "__blank")
  //   }
  //   close() {
  //     this.BlockDialog.hide();
  //     this.user_id = "";
  //   }
};
__decorateClass([
  Ref("blockDialog")
], BlockDialog.prototype, "BlockDialog", 2);
BlockDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], BlockDialog);
export {
  BlockDialog as default
};
